
const settingsEl = document.getElementById("pricesSetting");
const settings = settingsEl ? JSON.parse(settingsEl.dataset.values) : null;

export const includedStores = 1;

export function getIncludedSurgeries(surgeries) {
    return surgeries < 5 ? 1 : 5;
}

export function getDiscount() {
    return document.querySelector("[name='frequency']:checked").value === "0" ? settings.discountCoeficient : 1;
}

export function getPayingMonths() {
    return document.querySelector("[name='frequency']:checked").value === "0" ? 10 : 12;
}

export function getMonthTarifPrice(surgeries) {
    return surgeries > 4 ? settings.tarifProfiMonthlyPriceWithoutVat : settings.tarifStarterMonthlyPriceWithoutVat;
}

export function getMonthSurgeryPrice(surgeries) {
    return surgeries < 5 ? settings.starterExtraSurgeryMonthlyPriceWithoutVat : settings.profiExtraSurgeryMonthlyPriceWithoutVat;
}

export function getMonthStorePrice() {
    return settings.extraStoreMonthlyPriceWithoutVat;
}

export function getPriceWithDiscount(price) {
    price = Math.round(price);
    price = Math.round(price * getDiscount());
    return price;
}

export function getPriceWithVat(price) {
    price = Math.round(price);
    price = Math.round(price * settings.vat);
    return price;
}

export function getTotalMonthPrice(surgeries, stores) {
    let price = getPriceWithDiscount(getMonthTarifPrice(surgeries));
    price += (surgeries - getIncludedSurgeries(surgeries)) * getPriceWithDiscount(getMonthSurgeryPrice(surgeries));
    price += (stores - includedStores) * getPriceWithDiscount(getMonthStorePrice());

    return price;
}

export function getTotalMonthPriceWithVat(surgeries, stores) {
    let price = getPriceWithDiscount(getPriceWithVat(getMonthTarifPrice(surgeries)));
    price += (surgeries - getIncludedSurgeries(surgeries)) * getPriceWithVat(getPriceWithDiscount(getMonthSurgeryPrice(surgeries)));
    price += (stores - includedStores) * getPriceWithVat(getPriceWithDiscount(getMonthStorePrice()));

    return price;
}

export function getTotalYearPrice(surgeries, stores) {
    let price = getMonthTarifPrice(surgeries);
    price += (surgeries - getIncludedSurgeries(surgeries)) * getMonthSurgeryPrice(surgeries);
    price += (stores - includedStores) * getMonthStorePrice();

    return Math.round(getPayingMonths() * price);
}

export function getTotalYearPriceWithVat(surgeries, stores) {
    return getPriceWithVat(getTotalYearPrice(surgeries, stores));
}

export function showPrice(elementToShowIn, price) {
    let lang = document.documentElement.getAttribute("lang");
    let formatted = "";
    if (lang === "cs") {
        formatted = price.toLocaleString('cs-CZ', {
            style: 'currency',
            currency: 'CZK',
            maximumFractionDigits: 0
        });

    } else if (lang === "pl") {
        formatted = price.toLocaleString('pl-PL', {
            style: 'currency',
            currency: 'PLN',
            maximumFractionDigits: 0
        });
    } else {
        formatted = price.toLocaleString('en-UK', {
            style: 'currency',
            currency: 'EUR',
            maximumFractionDigits: 0
        });
    }

    if (elementToShowIn !== null) {
        elementToShowIn.innerHTML = `${formatted}`;
    }
}

export function getDiscountAmount() {
    return settings.discountAmount
}

export function showSalePercentage(elementToShowIn, amount) {
    elementToShowIn.innerHTML = `- ${amount} %`;
}
